<template>
  <div class="pros-verify-email">
    <div class="container no-padding">
      <div class="row no-margin">
        <div class="col-md-12" :class="showMenu ? 'opacity-8' : ''">
          <headerlogo :page-type="'2'" @slide-menu="slideMenu" />

          <div
            class="row no-padding main-body h-100"
            :style="{ height: windowHeight }"
          >
            <div class="col-sm-12 col-md-12 row my-auto no-padding no-margin">
              <div class="col-sm-12 col-12 col-md-12 row no-padding no-margin">
                <div
                  class="col-sm-12 col-md-4 offset-md-2 text-container tab-container no-padding flex-container"
                >
                  <div class="content-left">
                    <div class="verify-sec1">
                      {{ getUiText("app-prospect-callback-heading-1") }}
                    </div>
                    <div class="verify-sec2">
                      {{ getUiText("app-prospect-callback-heading-sub-1") }}
                    </div>
                    <div class="verify-sec3">
                      <span ref="infoDynamic" />
                    </div>
                    <div class="verify-sec4 display-flex">
                      <button
                        type="button"
                        data-cy="psp-verify-email-lets-go-button"
                        class="btn btn-primary letsgo-button"
                        @click="getQuestionsData"
                      >
                        {{
                          getUiText("app-prospect-callback-button-lets-go-1")
                        }}
                      </button>
                      <div
                        class="verify-sec4-enter-block d-sm-none d-md-block d-none d-sm-block"
                      >
                        <span class="enter-text">{{
                          getUiText("app-nav-press-enter-1")
                        }}</span>
                        <span class="enter-icon"
                          ><img src="@/assets/enter_icon.svg"
                        /></span>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="col-sm-12 col-md-6 tab-image-container flex-container no-padding"
                >
                  <!-- <img src="@/assets/img/brand_pattern.svg" class="img-laptop img-all" > -->
                  <brandpattern class="brand-pattern" :page="'VERIFY'" />
                  <img
                    src="@/assets/img/bg3.png"
                    class="img-laptop img-mobile"
                  />
                </div>
              </div>
            </div>
          </div>

          <errorhandler
            v-if="showProspectCallbackError || null"
            :prospect-callback-error-msg="prospectCallbackErrorMsg"
            @reset-show-prospect-callback-error="resetShowProspectCallbackError"
          />

          <div
            class="footer row d-sm-none d-md-block d-none d-sm-block page-footer no-margin"
          >
            {{ getUiText("app-prospect-nav-cms-text-1") }}
            <a href="https://cybersystem.io">{{
              getUiText("app-prospect-nav-cms-link-1")
            }}</a>
          </div>
        </div>

        <!-- 
        <div
          class="col-md-1 no-padding lg-menu-view"
          :style="{ 'min-height': dyn_height }"
        >
          <div class="right-menu">
            <div class="elipse-menu" @click="slideMenu">
              <span><img src="@/assets/img/elipse_menu.svg" /></span>
            </div>
          </div>
        </div>
        <sidebar
          :csrf-loaded="csrfLoaded"
          :show-menu="showMenu"
          @my-response="myResponse"
          @create-account="createAccount"
          @close-menu="closeMenu"
        />
        -->
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Vue, Watch } from "vue-facing-decorator";
import BrandPattern from "./brandPattern/brandPattern.vue";
import HeaderLogo from "@/components/common/headerLogo.vue";
import SideBar from "@/components/common/prospectQuestionsMenu.vue";
import Utils from "@/utils/utilities";
import { load } from "recaptcha-v3";
// import { namespace } from "vuex-class";
import errorhandler from "@/components/common/exceptionHandler.vue";
import store from "@/store";
import $ from "jquery";

// const LanguagePickerModule = namespace("LanguagePicker");

@Component({
  components: {
    brandpattern: BrandPattern,
    headerlogo: HeaderLogo,
    sidebar: SideBar,
    errorhandler,
  },
})
export default class ProspectVerifyEmail extends Vue {
  public showMenu = false;
  public dyn_height = "0";
  public windowHeight = "";
  public csrfLoaded = false;
  public showProspectCallbackError = false;
  public prospectCallbackErrorMsg = "";

  public infoTags: any = {
    "app-prospect-callback-info-link-1": { openTag: "<u>", closeTag: "</u>" },
  };

  get languageSelected() {
    return store.state.LanguagePicker.languageSelected;
  }
  get defaultUiText() {
    return store.state.LanguagePicker.defaultUiText;
  }
  get languageSelectedText() {
    return store.state.LanguagePicker.languageSelectedText;
  }

  @Watch("languageSelected")
  onChangeLanguageSelected() {
    setTimeout(() => {
      this.updateUIVariables();
    }, 50);
  }

  created() {
    if (
      sessionStorage.getItem("prospectCallbackInfo") !== "" &&
      (sessionStorage.getItem("prospectCallbackInfo") as string) !== null &&
      (sessionStorage.getItem("prospectCallbackInfo") as string).length > 0
    ) {
      // Can continue from here.
    } else {
      //Redirect to landing page if info not exists in sessionStorage.
      // this.$router.push({ path: "/" });
    }
    window.addEventListener("keyup", this.keyPressed);
    this.setLanguages();
  }
  mounted() {
    this.$nextTick(() => {
      this.onResize();
      window.addEventListener("resize", this.onResize);
      this.updateUIVariables();
    });
  }

  getUiText(id: string, isArray = false) {
    return Utils.getUiText(
      id,
      this.languageSelectedText,
      this.defaultUiText,
      isArray,
    );
  }
  getProcessedUIText(id: string, tags: any) {
    return Utils.getProcessedUIText(
      id,
      tags,
      this.languageSelectedText,
      this.defaultUiText,
    );
  }
  updateUIVariables() {
    let info = this.getProcessedUIText(
      "app-prospect-callback-info-1",
      this.infoTags,
    );
    $(this.$refs.infoDynamic as any).html(info);
  }

  onResize() {
    this.dyn_height = (window.innerHeight + "px") as string;

    if (window.innerHeight > 700) {
      if (window.innerHeight < 800 && window.innerHeight < window.innerWidth) {
        this.windowHeight = "auto !important" as string;
      } else if (
        window.innerWidth < 900 &&
        window.innerWidth < window.innerHeight
      ) {
        this.windowHeight = "auto !important" as string;
      } else if (window.innerHeight > 1200) {
        this.windowHeight = (window.innerHeight -
          200 +
          "px !important") as string;
      } else if (window.innerWidth > 1024) {
        if (window.innerHeight > 800) {
          this.windowHeight = window.innerHeight - 70 + "px !important";
        } else {
          this.windowHeight = window.innerHeight - 100 + "px !important";
        }
      } else {
        this.windowHeight = window.innerHeight - 100 + "px !important";
      }
    } else {
      this.windowHeight = "auto !important" as string;
    }
  }

  async setLanguages() {
    await Utils.getV3Recaptcha().then(
      async (finalKey: any) => {
        localStorage.removeItem("csrfReloadDone");
        const captchKey = finalKey;
        const recaptcha = await load(`${captchKey}`, {
          autoHideBadge: true,
        });
        recaptcha.execute("submit").then((token) => {
          this.$store.dispatch("LanguagePicker/setLanguages", token);
        });
        recaptcha.execute("submit").then((token) => {
          this.$store.dispatch("LanguagePicker/setLanguageList", token);
        });
      },
      (error: any) => {
        if (error && error.data && error.data.error && error.data.error.type) {
          if (error.data.error.type === "exc_session_invalid-1") {
            sessionStorage.setItem(
              "prospectCallbackErrorInfo",
              JSON.stringify(error.data.error),
            );
            this.$router.push({ path: "/" });
          } else {
            this.showErrorInfo(error.data.error);
          }
        } else if (error.data.message === "invalid csrf token") {
          this.$router.go(0);
        } else {
          this.showErrorInfo(error.data);
        }
      },
    );
  }

  showErrorInfo(errorInfo: any) {
    if (errorInfo && errorInfo !== "") {
      errorInfo =
        typeof errorInfo === "string" ? JSON.parse(errorInfo) : errorInfo;
      if (errorInfo && Object.keys(errorInfo).length > 0 && errorInfo.message) {
        this.showProspectCallbackError = true;
        this.prospectCallbackErrorMsg = errorInfo.message;
      }
    }
  }
  resetShowProspectCallbackError() {
    this.showProspectCallbackError = false;
    this.prospectCallbackErrorMsg = "";
  }

  keyPressed(e: any) {
    if (e.keyCode == 13) {
      this.getQuestionsData();
    }
  }

  closeMenu() {
    this.showMenu = false;
  }
  slideMenu() {
    this.showMenu = true;
  }

  async getQuestionsData() {
    await this.$store.dispatch("ProspectQuestions/setAllToDefaultData"); // To clear existing data in store.
    this.$router.push({ path: "/prospect/createaccount" });
    // this.$router.push({ path: "/prospect/questions" }).catch(() => {});
  }
  myResponse() {
    this.$router.push({ path: "/prospect/responses" });
  }
  createAccount() {
    this.$router.push({ path: "/prospect/createaccount" });
  }
  beforeUnmount() {
    window.removeEventListener("keyup", this.keyPressed);
  }
}
</script>
<style lang="scss" scoped>
.pros-verify-email {
  background: linear-gradient(
      90deg,
      rgba(238, 239, 240, 0.38) 50%,
      #ffffff 94.92%
    ),
    #ffffff;
}
.verify-sec1 {
  font-style: normal;
  font-weight: 500;
  font-size: 42px;
  line-height: 140%;
  color: #231f20;
}
.verify-sec2 {
  margin-top: 26px;
  position: relative;
  font-style: normal;
  font-weight: normal;
  font-size: 22px;
  line-height: 170%;
  color: #231f20;
}
.verify-sec3 {
  margin-top: 40px;
  position: relative;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 22px;
  color: #231f20;
}
.verify-sec4 {
  margin-top: 70px;
  position: relative;

  .verify-sec4-enter-block {
    margin-left: 40px;
    display: flex;
    align-items: center;
  }
  .letsgo-button {
    width: 118px;
    height: 41px;
    box-shadow: 0px 2px 4px rgba(33, 31, 88, 0.25);
    border-radius: 26.9091px;
    background: #0345bd;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
  }
  .enter-text {
    margin-top: 47px;
    width: 88px;
    height: 24px;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    display: contents;
    align-items: center;
    color: #231f20;
  }
  .enter-icon {
    margin-top: -5px;
    margin-left: 6px;
  }
}
.width-280 {
  right: 0px;
}
.width-0 {
  right: -100%;
}
.right-top-menu {
  top: 0px;
  width: 280px;
  background: #0345bd;
  box-shadow: inset 0px 2px 4px rgba(33, 31, 88, 0.15);
  position: fixed;
  height: 100%;
  overflow-x: hidden;
  -webkit-transition: right 0.5s ease;
  -moz-transition: right 0.5s ease;
  -o-transition: right 0.5s ease;
  -ms-transition: right 0.5s ease;
  transition: right 0.5s ease;
  z-index: 1060;

  .menu-content {
    margin-top: 50.4px;
  }
  .menu-close {
    .close {
      color: #211f58;
      opacity: 1 !important;
      padding-right: 41px;
    }
    img {
      width: 19.09px;
      height: 19.09px;
    }
  }

  .menu-content-sec {
    display: inline-grid;
    margin-top: 56.45px;
  }

  .menu-content-sec1 {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    text-align: right;
    color: #ffffff;
    padding-right: 41px;
  }

  .menu-content-sec2 {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    text-align: right;
    color: #ffffff;
    margin-top: 47px;
    padding-right: 41px;
  }

  .menu-content-sec3 {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 21px;
    text-align: right;
    margin-top: 116px;
    position: relative;
    color: #ffffff;
    padding-right: 41px;

    a {
      color: #ffffff;
      font-weight: bold;
      text-decoration: underline;
    }
  }

  .menu-content-last {
    bottom: 0px;
    position: absolute;
    padding-bottom: 41.5px;
    right: 45px;
    float: right;

    img {
      width: 123px;
      height: 27.53px;
    }
  }
}
.elipse-menu {
  cursor: pointer;
  position: relative;
  text-align: center;
  top: 32px;
}
.elipse-menu-mb {
  cursor: pointer;
  position: static;
  text-align: center;
  top: unset;
}
.right-menu {
  background: rgba(238, 239, 240, 0.3);
  height: 100%;
}
.menu-separation {
  border-bottom: 1px solid #ffffff;
  padding-top: 50px;
  opacity: 0.1;
}
.text-container {
  z-index: 1;
}
.tab-image-container {
  position: relative;
  .brand-pattern {
    position: absolute;
  }
}
</style>
